import getTranslations from "../../../i18n";
import { hydrate } from "react-dom";
import App from "../../containers/App";
import { getLocale } from "../../state/modules/config/selectors";
import setupRouteChangeListener from "../setupRouteChangeListener";
import { loadableReady } from "@loadable/component";
import { ConnectedRouter as Router } from "connected-react-router";
import getSavedItemsSummary from "../saveForLater/getSavedItemsSummary";

const bootstrapReact = async store => {
  store.dispatch(getSavedItemsSummary());

  const history = setupRouteChangeListener(store);

  const [translations] = await Promise.all([
    getTranslations(getLocale(store.getState()))
  ]);

  loadableReady(() => {
    hydrate(
      <App
        store={store}
        translations={translations}
        history={history}
        RouterComponent={Router}
      />,
      document.getElementById("plp")
    );
  });
};

export default bootstrapReact;
